import React from "react";
import "./ProgressBar.css";

export interface Step {
  icon: string;
  label: string;
}

export interface ProgressBarProps {
  steps: Step[];
  currentStep: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ steps, currentStep }) => {
  currentStep = currentStep - 1;
  return (
    <div className="stepper-wrapper">
      {steps.map((step, index) => (
        <div
          key={index}
          className={`stepper-item ${
            index < currentStep
              ? "completed"
              : index === currentStep
              ? "active"
              : ""
          }`}
        >
          {index > 0 && (
            <div
              className={`line left ${
                index <= currentStep || index > currentStep ? "completed" : ""
              }`}
            ></div>
          )}
          <div className="step-icon-wrapper">
            <img className="step-icon" src={step.icon} alt="icon"></img>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`line right ${index < currentStep ? "completed" : ""}`}
            ></div>
          )}
          <div className="step-name">{step.label}</div>
        </div>
      ))}
    </div>
  );
};

export default ProgressBar;
